module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.links !== false) ? _c('menu', {
    staticClass: "valign"
  }, [(_vm.mobile) ? [(!_vm.mobMenuShow && _vm.links[0].name != '') ? _c('router-link', {
    staticClass: "valign menu-btn menu-btn__left",
    attrs: {
      "to": _vm.links[0].path
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaNav($event)
      }
    }
  }, [_c('Arrow'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.links[0].name))])], 1) : _vm._e(), _vm._v(" "), (!_vm.mobMenuShow && _vm.links[0].name != '') ? _c('router-link', {
    staticClass: "valign menu-btn menu-btn__right",
    attrs: {
      "to": _vm.links[1].path
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaNav($event)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.links[1].name))]), _vm._v(" "), _c('Arrow')], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.mobile) ? [(!_vm.mobMenuShow && _vm.links[0].name != '') ? _c('div', {
    staticClass: "anim-nav-menu"
  }, [_c('div', {
    staticClass: "anim-container"
  }, [_c('div', {
    class: 'anim-wrapper ' + _vm.animTurn
  }, [_c('router-link', {
    staticClass: "menu-btn left",
    attrs: {
      "to": "/recipes"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaNav($event)
      }
    }
  }, [_c('Arrow'), _c('span', [_vm._v("Рецепты")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "menu-btn top",
    attrs: {
      "to": _vm.testNavLink
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaNav($event)
      }
    }
  }, [_c('Arrow'), _c('span', [_vm._v("Тест")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "menu-btn right",
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaNav($event)
      }
    }
  }, [_c('Arrow'), _c('span', [_vm._v("О продукте")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "menu-btn bottom",
    attrs: {
      "to": _vm.bottomNav.link
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaNav($event)
      }
    }
  }, [_c('Arrow'), _c('span', [_vm._v(_vm._s(_vm.bottomNav.text))])], 1)], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/ellipse.png",
      "alt": ""
    }
  })])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn-share",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSharing($event)
      }
    }
  }, [_c('Share')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "social-wrapper"
  }, [_c('social-sharing', {
    staticClass: "social social-click",
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('a', {
            staticClass: "fb",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/fb.svg",
              "alt": "Facebook"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "tw",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/twitter.svg",
              "alt": "Twitter"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "vk",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "vk"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/vk.svg",
              "alt": "Vkontakte"
            }
          })])], 1)])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "ok",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.shareOk($event)
      }
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": "/static/svg/ok.svg",
      "alt": "Vkontakte"
    }
  })])])], 1) : _vm._e()]), _vm._v(" "), (_vm.mobile) ? _c('a', {
    staticClass: "mobile-menu-btn desktop-hidden",
    class: {
      close: _vm.mobMenuShow
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.mobMenuToggle($event)
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mobMenuShow) ? _c('div', {
    staticClass: "mobile-menu-wrap desktop-hidden"
  }, [_c('div', {
    staticClass: "valign"
  }, [_c('h3', {
    staticClass: "mobile-menu-title"
  }, [_vm._v("Содержание")]), _vm._v(" "), _c('ul', {
    staticClass: "mobile-menu"
  }, [_c('li', [_c('router-link', {
    staticClass: "menu-link",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.mobMenuToggle($event)
      }
    }
  }, [_vm._v("Наш тест")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "menu-link",
    attrs: {
      "to": "/recipes"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.mobMenuToggle($event)
      }
    }
  }, [_vm._v("Рецепты")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "menu-link",
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.mobMenuToggle($event)
      }
    }
  }, [_vm._v("О продукте")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "social-wrapper"
  }, [_c('social-sharing', {
    staticClass: "social",
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('a', {
            staticClass: "fb",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/fb.svg",
              "alt": "Facebook"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "tw",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/twitter.svg",
              "alt": "Twitter"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "vk",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "vk"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/vk.svg",
              "alt": "Vkontakte"
            }
          })])], 1)])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "ok",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.shareOk($event)
      }
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": "/static/svg/ok.svg",
      "alt": "Vkontakte"
    }
  })])])], 1)])]) : _vm._e()])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a503467e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MainNav.vue
// module id = 105
// module chunks = 0